import { render } from "./OperarioParametros.vue?vue&type=template&id=74bcbd7e"
import script from "./OperarioParametros.vue?vue&type=script&lang=js"
export * from "./OperarioParametros.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__